import { useState } from "react";

import {
  MdAdd,
  MdClose,
  MdDeleteOutline,
  MdShoppingCart,
} from "react-icons/md";

import "./CustomOrderModal.css";

function CustomOrderModal({
  provider,
  providerType = "Food Provider",
  onClose,
  onSubmit,
}) {

  // =========================================================
  // CATERING CHECK
  // =========================================================

  const isCatering =
    providerType === "Catering";


  // =========================================================
  // GENERIC CUSTOM ORDER STATE
  // Bakery / Provision / Home Chef
  // =========================================================

  const [items, setItems] = useState([
    {
      id: Date.now(),
      itemName: "",
      quantity: "",
      unit: "gm",
    },
  ]);


  // =========================================================
  // CATERING STATE
  // =========================================================

  const [
    functionName,
    setFunctionName,
  ] = useState("");


  const [
    functionDate,
    setFunctionDate,
  ] = useState("");


  const [
    guests,
    setGuests,
  ] = useState("");


  const [
    menuItems,
    setMenuItems,
  ] = useState([
    {
      id: Date.now(),
      itemName: "",
    },
  ]);


  const [
    description,
    setDescription,
  ] = useState("");


  // =========================================================
  // EXISTING GENERIC SPECIAL INSTRUCTIONS
  // =========================================================

  const [
    specialInstructions,
    setSpecialInstructions,
  ] = useState("");


  // =========================================================
  // SUBMITTING
  // =========================================================

  const [
    submitting,
    setSubmitting,
  ] = useState(false);


  // =========================================================
  // ERROR
  // =========================================================

  const [
    error,
    setError,
  ] = useState("");


  // =========================================================
  // PROVIDER ID
  // =========================================================

  const providerId =
    provider?._id ||
    provider?.id ||
    null;


  // =========================================================
  // PROVIDER NAME
  // =========================================================

  const providerName =
    provider?.business?.name ||
    provider?.business?.businessName ||
    provider?.name ||
    "HomeFoods Provider";


  // =========================================================
  // GENERIC ITEM
  // ADD ITEM
  // =========================================================

  const handleAddItem = () => {

    setItems((previous) => [

      ...previous,

      {
        id:
          Date.now() +
          Math.random(),

        itemName: "",

        quantity: "",

        unit: "gm",
      },

    ]);

  };


  // =========================================================
  // GENERIC ITEM
  // REMOVE ITEM
  // =========================================================

  const handleRemoveItem = (id) => {

    setItems((previous) => {

      if (previous.length === 1) {

        return previous;

      }

      return previous.filter(
        (item) =>
          item.id !== id
      );

    });

  };


  // =========================================================
  // GENERIC ITEM
  // UPDATE
  // =========================================================

  const handleItemChange = (
    id,
    field,
    value
  ) => {

    setItems((previous) =>
      previous.map((item) => {

        if (
          item.id !== id
        ) {

          return item;

        }

        return {

          ...item,

          [field]:
            value,

        };

      })
    );

  };


  // =========================================================
  // CATERING MENU ITEM
  // ADD
  // =========================================================

  const handleAddMenuItem = () => {

    setMenuItems((previous) => [

      ...previous,

      {
        id:
          Date.now() +
          Math.random(),

        itemName: "",
      },

    ]);

  };


  // =========================================================
  // CATERING MENU ITEM
  // REMOVE
  // =========================================================

  const handleRemoveMenuItem = (id) => {

    setMenuItems((previous) => {

      if (previous.length === 1) {

        return previous;

      }

      return previous.filter(
        (item) =>
          item.id !== id
      );

    });

  };


  // =========================================================
  // CATERING MENU ITEM
  // UPDATE
  // =========================================================

  const handleMenuItemChange = (
    id,
    value
  ) => {

    setMenuItems((previous) =>
      previous.map((item) => {

        if (
          item.id !== id
        ) {

          return item;

        }

        return {

          ...item,

          itemName:
            value,

        };

      })
    );

  };


  // =========================================================
  // SUBMIT
  // =========================================================

  const handleSubmit = async (
    event
  ) => {

    event.preventDefault();

    setError("");


    // =======================================================
    // PROVIDER VALIDATION
    // =======================================================

    if (!providerId) {

      setError(
        "Provider information is unavailable."
      );

      return;

    }


    // =======================================================
    // PROVIDER TYPE VALIDATION
    // =======================================================

    const allowedProviderTypes = [

      "Home Chef",

      "Bakery",

      "Catering",

      "Provision Store",

    ];


    if (
      !allowedProviderTypes.includes(
        providerType
      )
    ) {

      setError(
        "Custom orders are currently available only for Home Chefs, Bakeries, Caterers and Provision Stores."
      );

      return;

    }


    // =======================================================
    // CATERING VALIDATION
    // =======================================================

    if (isCatering) {

      // -----------------------------------------------------
      // FUNCTION NAME
      // -----------------------------------------------------

      if (
        !functionName.trim()
      ) {

        setError(
          "Please enter the function name."
        );

        return;

      }


      // -----------------------------------------------------
      // FUNCTION DATE
      // -----------------------------------------------------

      if (!functionDate) {

        setError(
          "Please select the function date."
        );

        return;

      }


      // -----------------------------------------------------
      // GUESTS
      // -----------------------------------------------------

      const guestCount =
        Number(guests);


      if (
        !Number.isFinite(
          guestCount
        ) ||
        guestCount <= 0
      ) {

        setError(
          "Please enter a valid number of guests."
        );

        return;

      }


      // -----------------------------------------------------
      // MENU ITEMS
      // -----------------------------------------------------

      if (
        menuItems.length === 0
      ) {

        setError(
          "Please add at least one menu item."
        );

        return;

      }


      const hasEmptyMenuItem =
        menuItems.some(
          (item) =>
            !item.itemName.trim()
        );


      if (
        hasEmptyMenuItem
      ) {

        setError(
          "Please complete all menu items before sending."
        );

        return;

      }


      // -----------------------------------------------------
      // PREPARE MENU ITEMS
      // -----------------------------------------------------

      const preparedMenuItems =
        menuItems.map(
          (item) => ({

            itemName:
              item.itemName.trim(),

          })
        );


      // -----------------------------------------------------
      // CATERING REQUEST
      // -----------------------------------------------------

      const orderDetails = {

        orderType:
          "custom",

        providerId:
          providerId,

        providerType:
          "Catering",

        functionName:
          functionName.trim(),

        functionDate:
          functionDate,

        guests:
          guestCount,

        menuItems:
          preparedMenuItems,

        description:
          description.trim(),

      };


      console.log(
        "🍽️ CATERING ORDER REQUEST:",
        orderDetails
      );


      // -----------------------------------------------------
      // SEND TO PARENT
      // -----------------------------------------------------

      try {

        setSubmitting(true);


        if (onSubmit) {

          await onSubmit(
            orderDetails
          );

        }


        // ---------------------------------------------------
        // RESET
        // ---------------------------------------------------

        setFunctionName("");

        setFunctionDate("");

        setGuests("");

        setMenuItems([

          {
            id:
              Date.now(),

            itemName:
              "",

          },

        ]);

        setDescription("");

        setError("");


      } catch (submitError) {

        console.error(
          "Catering Order Submit Error:",
          submitError
        );


        setError(
          submitError?.response?.data?.message ||
          submitError?.message ||
          "Unable to send catering order request."
        );

      } finally {

        setSubmitting(false);

      }


      return;

    }


    // =======================================================
    // EXISTING GENERIC ORDER VALIDATION
    // Bakery / Provision / Home Chef
    // =======================================================

    const validItems =
      items.filter(
        (item) =>
          item.itemName.trim() &&
          Number(item.quantity) > 0
      );


    if (
      validItems.length === 0
    ) {

      setError(
        "Please add at least one item with a valid quantity."
      );

      return;

    }


    const hasInvalidItem =
      items.some(
        (item) => {

          const hasName =
            item.itemName.trim();

          const hasQuantity =
            Number(item.quantity) > 0;

          return (
            !hasName ||
            !hasQuantity
          );

        }
      );


    if (
      hasInvalidItem
    ) {

      setError(
        "Please complete all item details before sending."
      );

      return;

    }


    // =======================================================
    // PREPARE EXISTING ITEMS
    // =======================================================

    const preparedItems =
      items.map(
        (item) => ({

          itemName:
            item.itemName.trim(),

          quantity:
            Number(item.quantity),

          unit:
            item.unit,

        })
      );


    // =======================================================
    // EXISTING ORDER DATA
    // =======================================================

    const orderDetails = {

      orderType:
        "custom",

      providerId:
        providerId,

      providerType:
        providerType,

      items:
        preparedItems,

      specialInstructions:
        specialInstructions.trim(),

    };


    console.log(
      "🛒 CUSTOM ORDER REQUEST:",
      orderDetails
    );


    // =======================================================
    // SEND EXISTING ORDER
    // =======================================================

    try {

      setSubmitting(true);


      if (onSubmit) {

        await onSubmit(
          orderDetails
        );

      }


      // -----------------------------------------------------
      // RESET
      // -----------------------------------------------------

      setItems([

        {
          id:
            Date.now(),

          itemName:
            "",

          quantity:
            "",

          unit:
            "gm",

        },

      ]);

      setSpecialInstructions("");

      setError("");


    } catch (submitError) {

      console.error(
        "Custom Order Submit Error:",
        submitError
      );


      setError(
        submitError?.response?.data?.message ||
        submitError?.message ||
        "Unable to send custom order request."
      );

    } finally {

      setSubmitting(false);

    }

  };


  // =========================================================
  // RENDER
  // =========================================================

  return (

    <div
      className="custom-order-overlay"
      onMouseDown={(event) => {

        if (
          event.target ===
          event.currentTarget
        ) {

          if (!submitting) {

            onClose();

          }

        }

      }}
    >

      <div className="custom-order-modal">


        {/* =================================================
            HEADER
        ================================================= */}

        <div className="custom-order-header">

          <div className="custom-order-header-left">

            <div className="custom-order-icon">

              <MdShoppingCart />

            </div>

            <div>

              <span className="custom-order-eyebrow">
                HomeFoods
              </span>

              <h2>
                {isCatering
                  ? "Create Catering Request"
                  : "Create Custom Order"}
              </h2>

              <p>
                {isCatering
                  ? "Tell the provider about your catering requirements"
                  : "Send your requirements to the provider"}
              </p>

            </div>

          </div>


          <button
            type="button"
            className="custom-order-close"
            onClick={onClose}
            disabled={submitting}
            aria-label="Close"
          >

            <MdClose />

          </button>

        </div>


        {/* =================================================
            PROVIDER
        ================================================= */}

        <div className="custom-order-provider">

          <div>

            <span>
              Ordering from
            </span>

            <strong>
              {providerName}
            </strong>

          </div>

          <span className="custom-order-provider-type">

            {providerType}

          </span>

        </div>


        {/* =================================================
            ERROR
        ================================================= */}

        {error && (

          <div className="custom-order-error">

            {error}

          </div>

        )}


        {/* =================================================
            FORM
        ================================================= */}

        <form
          className="custom-order-form"
          onSubmit={
            handleSubmit
          }
        >


          {/* =================================================
              CATERING FORM
          ================================================= */}

          {isCatering ? (

            <>

              {/* =============================================
                  FUNCTION DETAILS
              ============================================= */}

              <div className="custom-order-section">

                <div className="custom-order-section-title">

                  <div>

                    <h3>
                      Function Details
                    </h3>

                    <p>
                      Tell the caterer about your event
                    </p>

                  </div>

                </div>


                {/* =========================================
                    FUNCTION NAME
                ========================================= */}

                <div className="custom-order-field">

                  <label>
                    Function Name
                  </label>

                  <input
                    type="text"
                    value={
                      functionName
                    }
                    onChange={(
                      event
                    ) =>
                      setFunctionName(
                        event.target.value
                      )
                    }
                    placeholder="e.g. Wedding Reception"
                    maxLength={100}
                    disabled={
                      submitting
                    }
                  />

                </div>


                {/* =========================================
                    FUNCTION DATE
                ========================================= */}

                <div className="custom-order-field">

                  <label>
                    Function Date
                  </label>

                  <input
                    type="date"
                    value={
                      functionDate
                    }
                    min={
                      new Date()
                        .toISOString()
                        .split("T")[0]
                    }
                    onChange={(
                      event
                    ) =>
                      setFunctionDate(
                        event.target.value
                      )
                    }
                    disabled={
                      submitting
                    }
                  />

                </div>


                {/* =========================================
                    GUESTS
                ========================================= */}

                <div className="custom-order-field">

                  <label>
                    No. of Guests
                  </label>

                  <input
                    type="number"
                    min="1"
                    step="1"
                    value={
                      guests
                    }
                    onChange={(
                      event
                    ) =>
                      setGuests(
                        event.target.value
                      )
                    }
                    placeholder="e.g. 150"
                    disabled={
                      submitting
                    }
                  />

                </div>

              </div>


              {/* =============================================
                  MENU ITEMS
              ============================================= */}

              <div className="custom-order-section">

                <div className="custom-order-section-title">

                  <div>

                    <h3>
                      Menu Items
                    </h3>

                    <p>
                      Add the dishes you want for the function
                    </p>

                  </div>

                  <span>

                    {menuItems.length}{" "}

                    {menuItems.length === 1
                      ? "item"
                      : "items"}

                  </span>

                </div>


                <div className="custom-order-items">

                  {menuItems.map(
                    (
                      item,
                      index
                    ) => (

                      <div
                        className="custom-order-item"
                        key={
                          item.id
                        }
                      >

                        {/* ITEM NUMBER */}

                        <div className="custom-order-item-number">

                          {index + 1}

                        </div>


                        {/* ITEM FIELD */}

                        <div className="custom-order-item-fields">

                          <div className="custom-order-field item-name-field">

                            <label>
                              Menu Item
                            </label>

                            <input
                              type="text"
                              value={
                                item.itemName
                              }
                              onChange={(
                                event
                              ) =>
                                handleMenuItemChange(
                                  item.id,
                                  event.target.value
                                )
                              }
                              placeholder="e.g. Biryani, Paneer, Gulab Jamun"
                              maxLength={100}
                              disabled={
                                submitting
                              }
                            />

                          </div>

                        </div>


                        {/* DELETE */}

                        <button
                          type="button"
                          className="custom-order-remove"
                          onClick={() =>
                            handleRemoveMenuItem(
                              item.id
                            )
                          }
                          disabled={
                            submitting ||
                            menuItems.length === 1
                          }
                          aria-label={
                            `Remove menu item ${index + 1}`
                          }
                        >

                          <MdDeleteOutline />

                        </button>

                      </div>

                    )
                  )}

                </div>


                {/* ADD MENU ITEM */}

                <button
                  type="button"
                  className="custom-order-add-item"
                  onClick={
                    handleAddMenuItem
                  }
                  disabled={
                    submitting
                  }
                >

                  <MdAdd />

                  <span>
                    Add Another Menu Item
                  </span>

                </button>

              </div>


              {/* =============================================
                  DESCRIPTION
              ============================================= */}

              <div className="custom-order-section">

                <div className="custom-order-section-title">

                  <div>

                    <h3>
                      Description
                    </h3>

                    <p>
                      Add any additional requirements for the event
                    </p>

                  </div>

                </div>


                <textarea
                  className="custom-order-instructions"
                  value={
                    description
                  }
                  onChange={(
                    event
                  ) =>
                    setDescription(
                      event.target.value
                    )
                  }
                  placeholder={
                    "Example: Please have all food ready by 1 PM. " +
                    "Need separate arrangements for children, etc."
                  }
                  rows={5}
                  maxLength={1000}
                  disabled={
                    submitting
                  }
                />


                <div className="custom-order-character-count">

                  {
                    description.length
                  }
                  /1000

                </div>

              </div>


              {/* =============================================
                  CATERING INFORMATION
              ============================================= */}

              <div className="custom-order-info">

                <span>
                  💡
                </span>

                <p>

                  The caterer will review your function
                  details and menu requirements, calculate
                  the price per guest and send the final
                  amount for your approval.

                </p>

              </div>

            </>

          ) : (

            /* =================================================
               EXISTING GENERIC ORDER FORM
            ================================================= */

            <>

              {/* =================================================
                  ITEMS
              ================================================= */}

              <div className="custom-order-section">

                <div className="custom-order-section-title">

                  <div>

                    <h3>
                      Items
                    </h3>

                    <p>
                      Add everything you need in this order
                    </p>

                  </div>

                  <span>

                    {items.length}{" "}

                    {items.length === 1
                      ? "item"
                      : "items"}

                  </span>

                </div>


                <div className="custom-order-items">

                  {items.map(
                    (
                      item,
                      index
                    ) => (

                      <div
                        className="custom-order-item"
                        key={
                          item.id
                        }
                      >

                        <div className="custom-order-item-number">

                          {index + 1}

                        </div>


                        <div className="custom-order-item-fields">

                          <div className="custom-order-field item-name-field">

                            <label>
                              Item name
                            </label>

                            <input
                              type="text"
                              value={
                                item.itemName
                              }
                              onChange={(
                                event
                              ) =>
                                handleItemChange(
                                  item.id,
                                  "itemName",
                                  event.target.value
                                )
                              }
                              placeholder={
                                providerType ===
                                "Provision Store"
                                  ? "e.g. Salt, Sugar, Coffee"
                                  : providerType ===
                                    "Bakery"
                                    ? "e.g. Jalebi, Laddu, Cake"
                                    : "e.g. Food item"
                              }
                              maxLength={
                                100
                              }
                              disabled={
                                submitting
                              }
                            />

                          </div>


                          <div className="custom-order-field quantity-field">

                            <label>
                              Quantity
                            </label>

                            <input
                              type="number"
                              min="0.01"
                              step="0.01"
                              value={
                                item.quantity
                              }
                              onChange={(
                                event
                              ) =>
                                handleItemChange(
                                  item.id,
                                  "quantity",
                                  event.target.value
                                )
                              }
                              placeholder="0"
                              disabled={
                                submitting
                              }
                            />

                          </div>


                          <div className="custom-order-field unit-field">

                            <label>
                              Unit
                            </label>

                            <select
                              value={
                                item.unit
                              }
                              onChange={(
                                event
                              ) =>
                                handleItemChange(
                                  item.id,
                                  "unit",
                                  event.target.value
                                )
                              }
                              disabled={
                                submitting
                              }
                            >

                              <option value="gm">
                                gm
                              </option>

                              <option value="kg">
                                kg
                              </option>

                              <option value="ml">
                                ml
                              </option>

                              <option value="litre">
                                litre
                              </option>

                              <option value="piece">
                                piece
                              </option>

                              <option value="pieces">
                                pieces
                              </option>

                              <option value="box">
                                box
                              </option>

                              <option value="packet">
                                packet
                              </option>

                              <option value="dozen">
                                dozen
                              </option>

                              <option value="plate">
                                plate
                              </option>

                            </select>

                          </div>

                        </div>


                        <button
                          type="button"
                          className="custom-order-remove"
                          onClick={() =>
                            handleRemoveItem(
                              item.id
                            )
                          }
                          disabled={
                            submitting ||
                            items.length === 1
                          }
                          aria-label={
                            `Remove item ${index + 1}`
                          }
                        >

                          <MdDeleteOutline />

                        </button>

                      </div>

                    )
                  )}

                </div>


                <button
                  type="button"
                  className="custom-order-add-item"
                  onClick={
                    handleAddItem
                  }
                  disabled={
                    submitting
                  }
                >

                  <MdAdd />

                  <span>
                    Add Another Item
                  </span>

                </button>

              </div>


              {/* =================================================
                  SPECIAL INSTRUCTIONS
              ================================================= */}

              <div className="custom-order-section">

                <div className="custom-order-section-title">

                  <div>

                    <h3>
                      Special Instructions
                    </h3>

                    <p>
                      Tell the provider anything important
                    </p>

                  </div>

                </div>


                <textarea
                  className="custom-order-instructions"
                  value={
                    specialInstructions
                  }
                  onChange={(
                    event
                  ) =>
                    setSpecialInstructions(
                      event.target.value
                    )
                  }
                  placeholder={
                    "Example: Freshly prepared, less sugar, " +
                    "specific brand required, etc."
                  }
                  rows={4}
                  maxLength={
                    500
                  }
                  disabled={
                    submitting
                  }
                />


                <div className="custom-order-character-count">

                  {
                    specialInstructions.length
                  }
                  /500

                </div>

              </div>


              {/* =================================================
                  INFORMATION
              ================================================= */}

              <div className="custom-order-info">

                <span>
                  💡
                </span>

                <p>

                  You don't need to enter prices.
                  The provider will review your request,
                  add the prices and send the final amount
                  for your approval.

                </p>

              </div>

            </>

          )}


          {/* =================================================
              FOOTER
          ================================================= */}

          <div className="custom-order-footer">

            <button
              type="button"
              className="custom-order-cancel"
              onClick={
                onClose
              }
              disabled={
                submitting
              }
            >

              Cancel

            </button>


            <button
              type="submit"
              className="custom-order-submit"
              disabled={
                submitting
              }
            >

              {submitting ? (

                <>

                  <span className="custom-order-spinner" />

                  Sending...

                </>

              ) : (

                <>

                  <MdShoppingCart />

                  Send Order Request

                </>

              )}

            </button>

          </div>

        </form>

      </div>

    </div>

  );

}

export default CustomOrderModal;